import React, { useEffect, useState, useRef } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import {
  formatDateTime,
  formatDateUTC,
  formValidation,
  isBefore,
  isFormError,
  isFormRequired,
  toDateQuery,
} from 'helpers/format'
import { PaymentReq, SupplierInvoiceDetailReq, UpdateSupplierInvoiceReq } from 'Store/supplier-invoice/types'
import {
  getSupplierInvoiceDetailAPI,
  updateSaleOrderPaymentAPI,
  updateSupplierInvoiceAPI,
} from 'Store/supplier-invoice/api'
import {
  selectPaymentActionEvent,
  selectSupplierInvoiceActionEvent,
  selectSupplierInvoiceDetail,
  selectSupplierInvoiceDetailEvent,
} from 'Store/supplier-invoice/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/supplier-invoice/actions'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { selectAllSupplierList } from 'Store/supplier/selector'
import { selectProductsGrnList } from 'Store/stock/selector'
import ProductsTable from 'Pages/SupplierOrder/components/ProductsTable'
// import QuotationSummay from 'Pages/SupplierOrder/components/QuotationSummay'
import ClientInfo from 'Pages/SupplierOrder/components/ClientInfo'
import DeliveryInfo from 'Pages/SupplierOrder/components/DeliveryInfo'
import SupplierInvoiceInfo from './components/SupplierInvoiceInfo'
import SaleOrderPDF from 'Pages/SupplierOrder/components/SaleOrderPDF'
import { AppSelect, MultiUploadForm } from 'Components/form'
import {
  DocumentDefaultTitle,
  menuSupplierPaymentTypes,
  PaymentTypes,
  SupplierInvoiceStatus,
} from 'helpers/constanst'
import { cloneDeep } from 'lodash'
import AppDateItem from 'Components/form/AppDateItem'
import moment from 'moment'
import { ConfirmDailog } from 'Components/modal'
import InvoicePaymentInfo from './components/InvoicePaymentInfo'
import SaleInvoicePDF from './components/SaleInvoicePDF'
import PaymentModal from './components/PaymentModal'
import SummaryPayment from './components/SummaryPayment'
import { getUserLogin } from 'helpers/account'
import SaleOrderPDFDetail from 'Pages/SupplierOrder/components/SaleOrderPDFDetail'
import QuotationSummay from 'Pages/Quotation/components/QuotationSummay'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  onPaymentSuccess?: () => void
  id?: number
  viewMode?: boolean
}

const QuotationDetail: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    id = 0,
    detail,
    detailEvent,
    paymentActionEvent,
    onPaymentSuccess = () => {},
    viewMode = false,
  } = props

  const dispatch = useDispatch()
  const saleOrderPDF = useRef(null as any)
  const saleOrderLitePDF = useRef(null as any)
  const saleInvoicePDF = useRef(null as any)
  const requireFeild = ['payment_channel', 'payment_date']
  const initForm = {
    id: 0,
    payment_channel: '',
    payment_date: '',
    payment_slips: [],
    payment_status: SupplierInvoiceStatus.SUCCESS,
  } as UpdateSupplierInvoiceReq
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [formError, setFormError] = useState([] as string[])
  const [paymentDialog, setPaymentDialog] = useState(false)
  const [saleOrderPDFtitle, setSaleOrderPDFtitle] = useState(DocumentDefaultTitle.SALEORDER as string)
  const userInfo = getUserLogin()

  useEffect(() => {
    if (visible) {
      onGetDetail()
      setFormData(cloneDeep(initForm))
    }
  }, [visible])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  useEffect(() => {
    if (detail) {
      setFormData({
        id: detail?.id || 0,
        payment_channel: detail?.payment_channel || '',
        payment_date: detail?.payment_date || '',
        payment_slips: detail?.payment_slips || [],
        payment_status: detail?.payment_status || SupplierInvoiceStatus.WAITING,
      })
    }
  }, [detail])

  const onGetDetail = (): void => {
    const req: SupplierInvoiceDetailReq = {
      id,
    }
    dispatch(
      getSupplierInvoiceDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''),
    )
  }

  const onSaveData = (): void => {
    if (!validateForm()) return
    const req: UpdateSupplierInvoiceReq = {
      ...formData,
      payment_status: formData?.payment_status,
      payment_date: formatDateUTC(formData?.payment_date || ''),
      id,
    }
    dispatch(updateSupplierInvoiceAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onUpdate = (): void => {
    if (!validateForm()) return
    const req: UpdateSupplierInvoiceReq = {
      ...formData,
      payment_status: SupplierInvoiceStatus.SUCCESS,
      payment_date: formatDateUTC(formData?.payment_date || ''),
      id,
    }
    dispatch(updateSupplierInvoiceAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onPayment = (form: PaymentReq): void => {
    const req: PaymentReq = {
      ...form,
      officer: userInfo?.username || '',
      payment_date: formatDateUTC(form?.payment_date),
      //payment_date: '2022-06-20',
    }
    dispatch(updateSaleOrderPaymentAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setPaymentDialog(false)
    clearEvent()
    onSuccess()
  }

  const onPaymentEventSuccess = (): void => {
    setPaymentDialog(false)
    clearEvent()
    onPaymentSuccess()
    onGetDetail()
  }

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const onUpdateData = (val: string, key: string) => {
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const initPaymentInfo = () => {
    return {
      sale_order_no: detail?.sale_order_no || '',
      payment_channel: formData?.payment_channel || '',
      payment_date: formData?.payment_date || '',
      payment_slips: formData?.payment_slips || [],
      amount: detail?.total_remain_amount || 0,
      officer: '',
      reason: '',
    } as PaymentReq
  }

  const PaymentDailog = (
    <PaymentModal
      onCloseModal={() => setPaymentDialog(false)}
      visible={paymentDialog}
      depy_amount={detail?.total_remain_amount || 0}
      onConfirm={req => {
        onPayment(req)
      }}
      init_info={initPaymentInfo()}
    />
  )

  const renderFooterContent = () => {
    const btn = [] as any[]

    if (detail?.payment_status !== SupplierInvoiceStatus.SUCCESS) {
      btn.push(<PrimaryButton btnType="Cancel" text="บันทึกข้อมูล" onClick={onSaveData} />)
      btn.push(
        <PrimaryButton
          btnType="Primary"
          text="ชำระเงิน"
          onClick={() => {
            setPaymentDialog(true)
          }}
        />,
      )
    }

    return (
      <Space size="middle" align="baseline">
        {/* <PrimaryButton btnType="Cancel" text="ปิด" onClick={onCloseDrawer} /> */}
        {btn}
      </Space>
    )
  }

  const renderTitle = () => {
    return (
      <Row justify="start" gutter={[8, 8]} align="top">
        <Col>
          <Space direction="vertical" size="small">
            <Space size="small" wrap={true}>
              {`เลขที่สั่งซื้อ : ${detail?.sale_order_no}`}
            </Space>
            <Space size="small" wrap={true}>
              <SmallText>วันที่สั่งซื้อ : {formatDateTime(detail?.created_at || '')}</SmallText>
            </Space>
          </Space>
        </Col>
      </Row>
    )
  }

  const paymentForm = () => {
    return (
      <BoxWrapper>
        <BoxTitle>ข้อมูลการชำระเงิน</BoxTitle>
        <Row gutter={[30, 12]}>
          <Col md={12} xs={24}>
            <Row>
              <Col md={24} xs={24}>
                <AppSelect
                  name="payment_channel"
                  label="รูปแบบการชำระเงิน"
                  isRequired={isRequired('payment_channel')}
                  isError={isError('payment_channel')}
                  value={formData.payment_channel}
                  onChange={onUpdateData}
                  menu={menuSupplierPaymentTypes}
                />
              </Col>
              <Col md={24} xs={24}>
                <AppDateItem
                  label="วันที่ชำระเงิน"
                  placeHolder={'วันที่ชำระเงิน'}
                  isRequired={isRequired('payment_date')}
                  isError={isError('payment_date')}
                  onChange={(date: string) => onUpdateData(date, 'payment_date')}
                  date={formData.payment_date}
                  showTime={true}
                  disableDate={(date: any) => {
                    return formData.payment_channel == PaymentTypes.CHECK
                      ? undefined
                      : isBefore(
                          moment(date)
                            .subtract(0, 'days')
                            .startOf('day')
                            .toString(),
                        )
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Col md={12} xs={24}>
            <Row>
              <Col md={24} xs={24}>
                <MultiUploadForm
                  token={currentUser.accessToken}
                  onUpdateData={onUpdateData}
                  files={formData.payment_slips}
                  folder="supplier-payment-slips"
                  //listType="text"
                  isPrivate={true}
                  name="payment_slips"
                  description="ขนาดไม่เกิน 5MB ต่อไฟล์ (.png .jpg .pdf) สามารถอัพโหลดได้มากกว่า 1 รายการ"
                  isRequired={isRequired('payment_slips')}
                  isError={isError('payment_slips')}
                  label="Upload หลักฐานการรับชำระเงิน"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  return (
    <DetailDrawer
      title={renderTitle()}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={!viewMode && renderFooterContent()}
      width={'90%'}
      maskClosable={true}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      {PaymentDailog}
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <EventModal
        event={[paymentActionEvent]}
        enable={true}
        successCalback={onPaymentEventSuccess}
        errorCalback={clearEvent}
      />
      <Row justify="space-between" gutter={[16, 8]}>
        <Col md={24} xs={24}>
          <SupplierInvoiceInfo detail={detail} />
        </Col>
        <Col md={24} xs={24}>
          <ClientInfo detail={detail} />
        </Col>
        <Col md={24} xs={24}>
          <DeliveryInfo detail={detail} />
        </Col>
        <Col md={24} xs={24}>
          <ProductsTable
            products={detail?.products || []}
            viewMode={true}
            saleOrderPdfRef={saleOrderPDF}
            saleOrderLitePdfRef={saleOrderLitePDF}
            saleInvoicePdfRef={detail?.payment_status === SupplierInvoiceStatus.SUCCESS && saleInvoicePDF}
            quotation_no={detail?.quotation_no}
            detail={detail}
            onSelectTitle={setSaleOrderPDFtitle}
          />
        </Col>
        <Col md={12} xs={24}></Col>
        <Col md={8} xs={24}>
          <SummaryInfo>
            <QuotationSummay detail={detail} />
          </SummaryInfo>
        </Col>
        <Col md={12} xs={24}>
          <InvoicePaymentInfo payments={detail?.partials || []} detail={detail} onSuccess={onGetDetail} />
        </Col>
        <Col md={12} xs={24}>
          <SummaryPayment detail={detail} />
        </Col>
        {detail?.payment_status !== SupplierInvoiceStatus.SUCCESS && (
          <Col md={24} xs={24}>
            {paymentForm()}
          </Col>
        )}
      </Row>
      <SaleOrderPDFDetail
        orderDetail={detail}
        saleOrderLitePDF={saleOrderLitePDF}
        saleOrderPDF={saleOrderPDF}
        title={saleOrderPDFtitle}
      />
      <Row ref={saleInvoicePDF}>
        <Col span={24}>
          <SaleInvoicePDF detail={detail} />
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const SummaryInfo = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  //color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  margin-right: 20px;
`

const SmallText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectSupplierInvoiceActionEvent(state),
    detail: selectSupplierInvoiceDetail(state),
    detailEvent: selectSupplierInvoiceDetailEvent(state),
    supplierList: selectAllSupplierList(state),
    productsGrn: selectProductsGrnList(state),
    paymentActionEvent: selectPaymentActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(QuotationDetail)
